/* Safety shim to prevent null.querySelector crashes */
(function () {
  function NullNode() {}
  NullNode.prototype.querySelector = function () { return new NullNode(); };
  NullNode.prototype.querySelectorAll = function () { return []; };
  NullNode.prototype.addEventListener = function () {};
  NullNode.prototype.removeEventListener = function () {};
  NullNode.prototype.getAttribute = function () { return null; };
  NullNode.prototype.setAttribute = function () {};
  NullNode.prototype.removeAttribute = function () {};
  NullNode.prototype.appendChild = function () {};
  NullNode.prototype.classList = { add(){}, remove(){}, toggle(){}, contains(){ return false; } };
  NullNode.prototype.style = { setProperty(){} };

  var _docQS  = Document.prototype.querySelector;
  var _elQS   = Element.prototype.querySelector;
  var _docQSA = Document.prototype.querySelectorAll;
  var _elQSA  = Element.prototype.querySelectorAll;

  Document.prototype.querySelector = function (sel) {
    var n = _docQS.call(this, sel);
    return n || new NullNode();
  };
  Element.prototype.querySelector = function (sel) {
    var n = _elQS.call(this, sel);
    return n || new NullNode();
  };
  Document.prototype.querySelectorAll = function (sel) {
    var list = _docQSA.call(this, sel);
    return list || [];
  };
  Element.prototype.querySelectorAll = function (sel) {
    var list = _elQSA.call(this, sel);
    return list || [];
  };
})();
